import { render } from "./Footer.vue?vue&type=template&id=72ad3e0c&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=72ad3e0c&scoped=true&lang=css"

import exportComponent from "/Data/maps/detention/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72ad3e0c"]])

export default __exports__